import { Button } from "@material-ui/core";
import Card from "@material-ui/core/Card";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@saleor/components/Container";
// import Form from "@saleor/components/Form";
import PageHeader from "@saleor/components/PageHeader";
import { FormChange } from "@saleor/hooks/useForm";
// import SingleSelectField from "@saleor/components/SingleSelectField";
import { searchRider_search_edges } from "@saleor/motherOrders/types/searchRider";
import { FetchMoreProps } from "@saleor/types";
import * as React from "react";

import BatchAssignmentList from "../BatchAssignmentList";
import BatchAssignmentListHead, { Order } from "../BatchAssignmentListHead";

interface BatchAssignmentListPageProps extends FetchMoreProps {
  riders: searchRider_search_edges[];
  searchRider: (query: string) => void;
  validateOrder: (
    order_number: string,
    riderId: string,
    orders: Order[]
  ) => void;
  validateOrders: (orders: any[], riderId: string) => void;
  onAssignRider: () => void;
  change: FormChange;
  data: {
    riderId: string;
    riderName: string;
    order_code: string;
    orders: Order[];
  };
  disabledAssign: boolean;
  onDelete: (id: string) => void;
}

const useStyles = makeStyles(
  () => ({
    actionArea: {
      display: "flex",
      justifyContent: "flex-end",
      marginTop: "1em"
    },
    btnOngoing: {
      "&:hover": {
        backgroundColor: "#f5f5f5 !important"
      },
      background: "#FFFFFF !important",
      border: "1px solid #E5E5E5 !important"
    }
  }),
  { name: "BatchAssignmentListPage" }
);

const BatchAssignmentListPage: React.FC<BatchAssignmentListPageProps> = props => {
  const {
    hasMore,
    loading,
    onFetchMore,
    riders,
    searchRider,
    validateOrder,
    validateOrders,
    onAssignRider,
    change,
    data,
    disabledAssign,
    onDelete
  } = props;
  const classes = useStyles(props);

  return (
    <Container>
      <PageHeader title="Batch Assignment">
        <Button
          variant="contained"
          color="default"
          className={classes.btnOngoing}
        >
          ONGOING
        </Button>
      </PageHeader>
      {/* <Form initial={dispatchInitialData}>
        {({ data, change }) => ( */}
      <>
        <Card>
          <BatchAssignmentListHead
            change={change}
            data={data}
            riders={riders}
            onFetchMore={onFetchMore}
            hasMore={hasMore}
            loading={loading}
            searchRider={searchRider}
            validateOrder={validateOrder}
            validateOrders={validateOrders}
          />
          <BatchAssignmentList
            data={data}
            change={change}
            onDelete={onDelete}
          />
        </Card>
        <div className={classes.actionArea}>
          <Button
            variant="contained"
            color="primary"
            onClick={onAssignRider}
            disabled={data.orders.length < 1 || disabledAssign}
          >
            ASSIGN & SHIP
          </Button>
        </div>
      </>
      {/* )}
      </Form> */}
    </Container>
  );
};

export default BatchAssignmentListPage;
